export const NoiseOverlay = () => (
  <div
    aria-hidden="true"
    className="noise-overlay pointer-events-none fixed inset-0 z-[60] opacity-[0.045] mix-blend-overlay"
    data-testid="noise-overlay"
  />
);

export default NoiseOverlay;
